
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6h22c1.645 0 3 1.355 3 3v14c0 1.645-1.355 3-3 3H5c-1.645 0-3-1.355-3-3V9c0-1.645 1.355-3 3-3zm0 2c-.555 0-1 .445-1 1v14c0 .555.445 1 1 1h22c.555 0 1-.445 1-1V9c0-.555-.445-1-1-1H5zm1 7a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    